import React from "react";
import proptypes from "prop-types";
import { Typography } from "@one-thd/sui-atomic-components";
import { TooltipContent } from "./tooltip-content";

const { bool, shape, string } = proptypes;

export const AvailabilityTooltipContent = ({
  showMainTooltip = false,
  showUnavailableTooltip = false,
  shouldShowOOSTTooltip = false,
  hoveredCombinationDetails = {},
  unavailableTooltipMessage = "",
  oosTooltipMessage = ""
}) => {
  if (showMainTooltip) {
    return <TooltipContent hoveredCombinationDetails={hoveredCombinationDetails} />;
  }
  if (shouldShowOOSTTooltip) {
    return (
      <TooltipContent oosTooltipMessage={oosTooltipMessage} hoveredCombinationDetails={hoveredCombinationDetails} />
    );
  }

  if (showUnavailableTooltip) {
    return (
      <Typography variant="body-base" align="center">
        {unavailableTooltipMessage}
      </Typography>
    );
  }
  return null;
};

AvailabilityTooltipContent.propTypes = {
  showMainTooltip: bool,
  showUnavailableTooltip: bool,
  shouldShowOOSTTooltip: bool,
  hoveredCombinationDetails: shape({}),
  unavailableTooltipMessage: string,
  oosTooltipMessage: string
};
